'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FlickityConfigProvider = exports.FlickityConfigProvider = function () {
    function FlickityConfigProvider() {
        _classCallCheck(this, FlickityConfigProvider);

        // Define Flickity defaults
        this.accessibility = true;
        this.adaptiveHeight = false;
        this.autoPlay = false;
        this.cellAlign = 'center';
        this.cellSelector = undefined;
        this.contain = false;
        this.draggable = true;
        this.dragThreshold = 3;
        this.freeScroll = false;
        this.freeScrollFriction = false;
        this.selectedAttraction = .025;
        this.friction = .28;
        this.groupCells = false;
        this.initialIndex = 0;
        this.lazyLoad = true;
        this.percentPosition = true;
        this.prevNextButtons = true;
        this.pageDots = true;
        this.resize = true;
        this.rightToLeft = false;
        this.setGallerySize = true;
        this.watchCSS = false;
        this.wrapAround = false;
        this.imagesLoaded = true;
        this.asNavFor = true;
    }

    _createClass(FlickityConfigProvider, [{
        key: '$get',
        value: function $get() {
            return this;
        }
    }]);

    return FlickityConfigProvider;
}();


/** WEBPACK FOOTER **
 ** ./src/flickity.provider.js
 **/